// Modal "¿Por qué este nivel?" — explicación individual + factores del caso.
import React from 'react';
import { X } from 'lucide-react';
import { EXPLICACIONES_NIVEL, NIVELES, DISCLAIMER_NIVEL } from '../../../lib/dashboardVocab';

const FACTORES_LABEL = {
  evento_centinela:           'Evento centinela',
  caso_rojo_abierto:          'Nivel crítico activo',
  naranjo_sin_primera_accion: 'Sin primera acción registrada',
  caso_vencido:               'Seguimiento vencido',
  asignado_a_ti:              'Asignado al usuario en carril sensible',
  revision_programada_hoy:    'Revisión programada para hoy',
  reiteracion_15d:            'Reiteración en últimos 15 días',
  carril_clinico:             'Carril clínico / orientación',
  carril_crisis:              'Carril crisis',
  afectacion_alta:            'Afectación alta',
};

export default function PriorityExplanationModal({ open, onClose, nivel, motivos = [] }) {
  if (!open) return null;
  const info = EXPLICACIONES_NIVEL[nivel] || EXPLICACIONES_NIVEL.verde;
  const cfg = NIVELES[nivel] || NIVELES.verde;
  return (
    <div
      className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center px-4"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      data-testid="por-que-nivel-overlay"
    >
      <div
        className="bg-white rounded-2xl max-w-lg w-full shadow-xl"
        onClick={(e) => e.stopPropagation()}
        data-testid="por-que-nivel-modal"
      >
        <div className="px-6 py-4 border-b border-[#E5EAF5] flex items-center justify-between">
          <div className="flex items-center gap-2">
            <span className="w-3 h-3 rounded-full" style={{ background: cfg.dot }} />
            <h2 className="font-extrabold text-[#0B1B5E] text-lg">{info.titulo}</h2>
          </div>
          <button onClick={onClose} className="p-1 rounded hover:bg-[#F4F7FE]" aria-label="Cerrar" data-testid="por-que-nivel-close">
            <X className="w-5 h-5 text-[#475472]" />
          </button>
        </div>

        <div className="px-6 py-5 space-y-4">
          <div>
            <h3 className="text-xs font-bold uppercase tracking-wide text-[#475472] mb-1">Situación</h3>
            <p className="text-sm text-[#0B1B5E]">{info.descripcion}</p>
          </div>
          <div>
            <h3 className="text-xs font-bold uppercase tracking-wide text-[#475472] mb-1">Acción esperada</h3>
            <p className="text-sm text-[#0B1B5E]">{info.accion}</p>
          </div>
          {motivos.length > 0 && (
            <div data-testid="factores-nivel">
              <h3 className="text-xs font-bold uppercase tracking-wide text-[#475472] mb-2">
                Factores que explican este nivel
              </h3>
              <ul className="space-y-1.5">
                {motivos.map((m, i) => (
                  <li key={i} className="flex items-start gap-2 text-sm text-[#0B1B5E]">
                    <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-[#5346E6]" />
                    {FACTORES_LABEL[m] || m}
                  </li>
                ))}
              </ul>
            </div>
          )}
          <div className="p-3 rounded-lg bg-[#F4F7FE] text-xs text-[#475472] leading-relaxed border border-[#E5EAF5]">
            {DISCLAIMER_NIVEL}
          </div>
        </div>
      </div>
    </div>
  );
}
